<template>
  <div>
    <div class="section mb-2">
      <div class="section_header mb-3">
        <div class="row no-gutters align-items-center justify-content-between">
          <div class="col">
            <h2 class="section_header_title">
              {{ titulo }}
            </h2>
          </div>
        </div>
      </div>
    </div>

    <div class="box_body px-3 py-2">
      <div class="row no-gutters align-items-center">
        <div class="d-inline-flex box_body_content">
          <div class="d-inline-block mr-5">
            <ul class="box_list">
              <li class="box_list_item box_list_title">
                Endereço completo
              </li>

              <li class="box_list_item">
                <strong>{{ formatarEndereco(arquivoEstruturado) }}</strong>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'Endereco',
    props: {
      arquivoEstruturado: {
        type: Object,
        default: null
      },
      titulo: {
        type: String,
        default: 'Endereço'
      }
    },
    methods: {
      formatarEndereco (endereco) {
        if (!endereco) return 'Não informado'

        const cep = endereco.cep ? endereco.cep.replace(/(\d{5})(\d{3})/, '$1-$2') : null

        const enderecoFormatado = [
          `${endereco.logradouro || ''}${endereco.numero ? `, ${endereco.numero}` : ''}`,
          endereco.complemento,
          endereco.bairro,
          `${endereco.cidade || ''}${endereco.uf ? ` - ${endereco.uf}` : ''}`,
          cep
        ]

        return enderecoFormatado.filter(Boolean).join(', ')
      }
    }
  }
</script>

<style lang="scss" scoped>
@import "@/scss/_utilities/_exports";

.section {
  &_header {
    @extend %titleBox;
    background-color: $color-gray-light;

    &_title {
      @extend %titleBox_title;
    }
  }
}
.box {
  box-shadow: 0 0 pxToRem(4) 0 $color-dark;

  &_error {
    border: solid 2px #8B0000;
    border-radius: 2px;
  }

  &_header {
    background-color: #01AEC9;
    color: $color-dark;

    &_title {
      font-size: pxToRem(14);
      font-weight: 500;
    }
  }

  &_body {
    border-right: 2px solid #DDDDDD;
    border-bottom: 2px solid #DDDDDD;
    border-radius: 0 0 8px 8px;
  }

  &_list {
    font-size: pxToRem(14);
    list-style: none;
    margin: 0;
    padding: 0;

    &_item {}

    &_title {
      margin-bottom: pxToRem(4);
      text-decoration: underline;
    }
  }
}
</style>